import { useRef, useCallback, useEffect } from 'react';
import useTealium from './useTealium';
const useTooltipTimer = (options = {}) => {
    const { delay = 5000 } = options;
    const { trackEvent } = useTealium();
    const timerRef = useRef(null);
    const isTooltipOpenRef = useRef(false);
    const handleTooltipOpen = useCallback((eventData) => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        isTooltipOpenRef.current = true;
        timerRef.current = setTimeout(() => {
            if (isTooltipOpenRef.current) {
                trackEvent(eventData);
            }
        }, delay);
    }, [trackEvent, delay]);
    const handleTooltipClose = useCallback(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
            isTooltipOpenRef.current = false;
        }
    }, []);
    useEffect(() => {
        return () => {
            isTooltipOpenRef.current = false;
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);
    return {
        handleTooltipOpen,
        handleTooltipClose
    };
};
export default useTooltipTimer;
